import React, { useState, useEffect } from 'react';
import { Plus } from 'lucide-react';
import { Button } from '../../components/ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/card';
import DataTable from '../../components/admin/DataTable';
import RichTextEditor from '../../components/admin/RichTextEditor';

const PagesManagement = () => {
  const [pages, setPages] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showForm, setShowForm] = useState(false);
  const [editing, setEditing] = useState(null);
  const [formData, setFormData] = useState({
    slug: '', title_ar: '', title_en: '', content_ar: '', content_en: '',
    is_published: true, show_in_menu: false
  });

  const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || '';

  useEffect(() => { fetchPages(); }, []);

  const fetchPages = async () => {
    try {
      const response = await fetch(`${BACKEND_URL}/api/pages/all`, {
        headers: { 'Authorization': `Bearer ${localStorage.getItem('token')}` },
      });
      setPages(await response.json());
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const url = editing ? `${BACKEND_URL}/api/pages/${editing.id}` : `${BACKEND_URL}/api/pages/`;
      const response = await fetch(url, {
        method: editing ? 'PUT' : 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('token')}`,
        },
        body: JSON.stringify(formData),
      });
      if (response.ok) {
        fetchPages();
        resetForm();
        alert('تم الحفظ بنجاح');
      }
    } catch (error) {
      alert('حدث خطأ');
    }
  };

  const resetForm = () => {
    setFormData({
      slug: '', title_ar: '', title_en: '', content_ar: '', content_en: '',
      is_published: true, show_in_menu: false
    });
    setEditing(null);
    setShowForm(false);
  };

  const columns = [
    { header: 'الصفحة', accessor: 'title_ar' },
    { header: 'Slug', accessor: 'slug' },
    { header: 'في القائمة', render: (row) => row.show_in_menu ? 'نعم' : 'لا' },
  ];

  return (
    <div className="space-y-6">
      <div className="flex justify-between items-center">
        <h1 className="text-3xl font-bold text-[#0F388E]">إدارة الصفحات</h1>
        <Button onClick={() => setShowForm(!showForm)} className="bg-[#0F388E]">
          <Plus className="ml-2" />إضافة صفحة
        </Button>
      </div>

      {showForm && (
        <Card>
          <CardHeader><CardTitle>{editing ? 'تعديل' : 'إضافة'} صفحة</CardTitle></CardHeader>
          <CardContent>
            <form onSubmit={handleSubmit} className="space-y-4">
              <input type="text" placeholder="Slug (URL-friendly) *" value={formData.slug}
                onChange={(e) => setFormData({...formData, slug: e.target.value})}
                className="w-full px-4 py-2 border rounded-lg" required disabled={editing} />
              <input type="text" placeholder="العنوان *" value={formData.title_ar}
                onChange={(e) => setFormData({...formData, title_ar: e.target.value})}
                className="w-full px-4 py-2 border rounded-lg" required />
              <RichTextEditor label="المحتوى" value={formData.content_ar}
                onChange={(v) => setFormData({...formData, content_ar: v})} rows={10} />
              <div className="flex items-center gap-3">
                <input type="checkbox" id="show_in_menu" checked={formData.show_in_menu}
                  onChange={(e) => setFormData({...formData, show_in_menu: e.target.checked})}
                  className="w-5 h-5" />
                <label htmlFor="show_in_menu">إظهار في القائمة</label>
              </div>
              <div className="flex gap-3 justify-end">
                <Button type="button" variant="outline" onClick={resetForm}>إلغاء</Button>
                <Button type="submit">حفظ</Button>
              </div>
            </form>
          </CardContent>
        </Card>
      )}

      <Card>
        <CardContent className="pt-6">
          <DataTable columns={columns} data={pages}
            onEdit={(item) => { setEditing(item); setFormData(item); setShowForm(true); }}
            onDelete={async (item) => {
              await fetch(`${BACKEND_URL}/api/pages/${item.id}`, {
                method: 'DELETE',
                headers: { 'Authorization': `Bearer ${localStorage.getItem('token')}` },
              });
              fetchPages();
            }}
            loading={loading} />
        </CardContent>
      </Card>
    </div>
  );
};

export default PagesManagement;
